import { EmberRoute } from '../../enums/emberRoute'
import { useEmberRouteToUrlGenerator } from './useEmberRouteToUrlGenerator'

interface UseEmberRouteUrlResult {
  url: string | undefined
}

export const useEmberRouteUrl = (
  emberRoute: EmberRoute | undefined,
  ...args: Array<string | null | undefined>
): UseEmberRouteUrlResult => {
  const { generateUrl } = useEmberRouteToUrlGenerator()

  if (!generateUrl || !emberRoute) {
    return { url: undefined }
  }

  return { url: generateUrl(emberRoute, ...args) }
}
